export const selectProposalDashboardFilters = (state) => state.proposals.dashboardFilters.filters;
export const selectProposalDashboardRange = (state) => state.proposals.dashboardFilters.filters.range;
